import { createSelector } from 'reselect';
import get from 'lodash/get';
import moment from 'moment';
import { intervalSelector } from '@store/common/selectors';
import getGranularity from '@utils/granularity';
import { GranularityMap, getAllowedGranularity } from '@components/common/GranularitySelect/utils';
import { SCOPE } from './types';

const selector = (state) => get(state, SCOPE);

export default selector;

export const comparisonIntervalSelector = createSelector(
  selector,
  (comparisonStore) => comparisonStore.interval,
);

export const granularityMatchSelector = createSelector(
  intervalSelector,
  comparisonIntervalSelector,
  (interval, compareInterval) => {
    try {
      const granularity =
        interval.granularity || getGranularity({ from: interval.from, to: interval.to });
      const { unit = 'minute' } = GranularityMap[granularity] || {};

      // DoD uses the same granularity as main interval
      // check if it's supported by the compare interval
      const allowedCompareGranularity = getAllowedGranularity(compareInterval);

      return (
        allowedCompareGranularity.includes(granularity) &&
        moment(interval.from).diff(interval.to, unit) ===
          moment(compareInterval.from).diff(compareInterval.to, unit)
      );
    } catch {
      return false;
    }
  },
);
